module.exports = __webpack_public_path__ + "img/join_us.7ff54bf6.png";